import { createSlice } from "@reduxjs/toolkit";

const initialUserDetailsState = { data: {}, isOpen: false }

const userDetailsSlice = createSlice({
    name: 'userDetailsSlice',
    initialState: initialUserDetailsState,
    reducers: {
        openModal(state, action) {
            state.data = action.payload
            state.isOpen = true
        },
        closeModal(state, action) {
            state.data = {}
            state.isOpen = false
        }
    }
})

export const userDetailsActions = userDetailsSlice.actions;
export default userDetailsSlice